import { Controller } from "@hotwired/stimulus"

// If the user comes from a parent page, the back button returns
// to this page and keeps the parameters (typically pagination or filters).
//
// In all other cases, the back button returns to the fallback page.
//
export default class extends Controller {
  static values = { fallback: String, referrer: String }

  click() {
    var location = this.fallbackValue

    if (this.referrerValue && this.referrerValue.indexOf(`${window.location.origin}${this.fallbackValue}?`) != -1) {
      location = this.referrerValue
    }

    Turbo.visit(location)
  }
}
